export interface CruiseI {
	_id: string;
	name: string;
	description: string | null;
	created_at: Date;
	updated_at: Date;
	deleted_at?: Date | null;
	is_active?: Number;
}

//Reducer Types
export interface State {
	list?: CruiseI[];
	count: number;
}

export interface Cruise {
	cruise: State;
}

interface CruseListSuccess {
	type: "CRUISE_LIST_SUCCESS";
	payload: {
		list: CruiseI[];
		count: number;
	};
}

type Action = CruseListSuccess;

export const cruiseReducer = (
	state: State = {
		list: undefined,
		count: 0,
	},
	action: Action
): State => {
	switch (action.type) {
		case "CRUISE_LIST_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
			};

		default:
			return state;
	}
};
